#import "./AliyahDetailsWithParashah.graphql"
query AliyotDetailedQuery($parashah: ID!, $mine: Boolean!) {
  aliyot(parashah: $parashah, mine: $mine) {
    ...aliyahDetailsWithParashah
  }
}
